/**
 * List of possible tag types
 *
 * Every reader has a specific tag type, as defined in {@link tmrRfidReaderTypes}.
 * Websocket messages have different properties based on the scanning reader,
 * mapped here with the `codeProperty` option.
 *
 * @namespace tmrTagTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrTagTypes',
  {
    UHF: {
      codeProperty: 'epc',
    },
    NFC: {
      codeProperty: 'uid',
    },
  },
]
